import $ from 'jquery';
import {$Doc} from "../utils/jQueryGlobals";
import Component from "../models/Component";

export default class Toggle extends Component {
  constructor(element, context) {
    super(element, context);
    $(() => {
      this.toggleElem = this.getData('elem');
      if (this.toggleElem) {
        if (typeof this.toggleElem === 'string' && this.toggleElem.substring(0, 7) === 'closest') {
          let tmp = this.toggleElem.split(':');
          this.toggleElem = this.element.closest(tmp[1]);
        } else {
          this.toggleElem = this.toggleElem === 'parent' ? this.element.parent() : $(this.toggleElem);
        }
      }
      this.cls = this.getData('class', 'open');
      this.clickOutsideEvent = this.getData('click-outside-event');
      this.init();
    });
  }

  init() {
    this.element.on('click', (e) => this.toggle(e)).find('a').on('click', (e) => {
      e.stopPropagation()
    });
  }

  clickOutside() {
    if (this.toggleElem.hasClass(this.cls)) $Doc.on('click.' + this.clickOutsideEvent, (e) => {
      let t = $(e.target);
      if (!t.is(this.toggleElem) && !t.closest('.' + this.cls).is(this.toggleElem)) {
        this.toggleElem.removeClass(this.cls);
        $Doc.off('click.' + this.clickOutsideEvent);
      }
    });
  }

  toggle(e) {
    e.preventDefault();
    this.toggleElem.toggleClass(this.cls);
    if (this.getData('toggle-self')) {
      this.element.toggleClass(this.getData('toggle-self'));
    }
    this.toggleElem.trigger('toggle_' + this.cls, [this.toggleElem.hasClass(this.cls)]);
    if (this.clickOutsideEvent) {
      this.clickOutside();
    }
  }
}
